import CardVideoOfLeague from "components/CardVideoOfLeague"
import { Fragment } from "react"

function Video({ videos, tabVideo, onChangeTabVideo }) {
  return (
    <>
      <button
        className="py-1 md:py-2 px-4 rounded-full bg-dark mr-4 font-bold text-sm md:text-base mt-2 md:mt-0"
        onClick={() => {
          onChangeTabVideo("all")
        }}
        style={tabVideo === "all" ? { backgroundColor: "#0593E9", color: "#0E1E3E" } : {}}
      >
        Tất cả
      </button>
      <button
        className="py-1 md:py-2 px-4 rounded-full bg-dark mr-4 font-bold text-sm md:text-base"
        onClick={() => {
          onChangeTabVideo("highlight")
        }}
        style={tabVideo === "highlight" ? { backgroundColor: "#0593E9", color: "#0E1E3E" } : {}}
      >
        Highlight
      </button>
      {/* <button
        className="py-1 md:py-2 px-4 rounded-full bg-dark mr-4 font-bold text-sm md:text-base"
        onClick={() => {
          onChangeTabVideo("fullmatch")
        }}
        style={tabVideo === "fullmatch" ? { backgroundColor: "#0593E9", color: "#0E1E3E" } : {}}
      >
        Full match
      </button> */}
      <section className=" mt-4 md:pt-10 max-w-screen-xl  md:px-12  mx-0 2xl:px-0">
        <div className="mb-8 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 3xl:grid-cols-4 gap-x-6 max-w-screen-xl m-auto gap-y-6">
          {videos?.length > 0 &&
            videos?.map((item, index) => {
              return (
                <div key={index}>
                  <CardVideoOfLeague {...item} showText={false} />
                </div>
              )
            })}
        </div>
        {videos?.length <= 0 && (
          <div className="text-sm md:text-base text-center md:text-left">Nội dung đang được cập nhật !</div>
        )}
      </section>
    </>
  )
}
export default Video
